import { FilterSection, AdvancedFilters } from "../../../../components/ui";
import { LEAD_STAGES, SORT_OPTIONS, getLeadsFilterConfig } from "@/constants/globalConstants";
import { useAuthStore } from "@/store/authStore";

export const LeadsFilterSection = ({
  search, setSearch,
  filters, setFilters,
  sortBy, setSortBy,
  showAdvancedFilters, setShowAdvancedFilters,
  view, setView,
  onAddClick,
  onExport,
  isExporting,
  filterOptions = { locations: [], sources: [] },
  activityStats,
  onReset
}) => {
  const { user } = useAuthStore();
  const userRole = (user?.role || "").toLowerCase().trim().replace(/[-_\s]+/g, "-");
  
  const currentStages = ["sales-exec", "sale-exec", "sale-executive", "sales-executive"].includes(userRole)
    ? LEAD_STAGES.filter(s => s.key !== "new")
    : LEAD_STAGES;

  const filterConfig = getLeadsFilterConfig(filterOptions, currentStages);

  return (
    <FilterSection
      search={search}
      setSearch={setSearch}
      filters={filters}
      setFilters={setFilters}
      // viewStyle={view}
      // setViewStyle={setView}
      onAddClick={onAddClick}
      addLabel="Add Lead"
      onExport={onExport}
      isExporting={isExporting}
      isAdvancedFilterInline={true}
      statusOptions={currentStages.map(s => ({ value: s.key, label: s.label }))}
      statusPlaceholder="All Lead Stages"
      AdvancedFiltersComponent={({ isInline }) => (
        <AdvancedFilters
          filters={filters}
          onFilterChange={(key, value) => setFilters(prev => ({ ...prev, [key]: value }))}
          sortBy={sortBy}
          onSortChange={setSortBy}
          sortOptions={SORT_OPTIONS}
          config={filterConfig}
          isInline={isInline}
        />
      )}
    />
  );
};
